
import { defineComponent, computed, reactive } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "@/store/store";
import useUser from "@/hooks/useUser";
import useRepos from "@/hooks/useRepos";
import Repositories from "@/components/Repositories.vue";
import { getTopStarsRepos } from "@/utils/helper";
import PageControl from "@/components/PageControl.vue";

export default defineComponent({
  name: "Github-user",
  components: {
    Repositories,
    PageControl
  },
  async setup() {
    const store: Store = useStore();
    const router = useRouter();
    const { state, getters } = store;
    const fullName = getters.fullName();
    const { userInfo, error } = await useUser(state.githubUsername);
    const { userRepos } = await useRepos(state.githubUsername);
    const nextStep = reactive({
      action: () => {
        router.push("/request-form");
      },
      isDisabled: false,
      label: "Go Back to Search Page"
    });
    const previousStep = reactive({
      action: () => {
        router.push("/");
      },
      isDisabled: false,
      label: "Home"
    });

    // handle the error  or response on repository items
    const reposItemCheck = computed(() => {
      let reposItem: Repo[] | undefined = [];
      const { value } = userRepos;
      if (!error.value) {
        reposItem = getTopStarsRepos(value, 3);
      }
      return reposItem;
    });

    return {
      userInfo,
      error,
      fullName,
      status,
      reposItemCheck,
      nextStep,
      previousStep
    };
  }
});
